import { render, staticRenderFns } from "./AdminAlertMessage2.vue?vue&type=template&id=40acdb19&scoped=true"
import script from "./AdminAlertMessage2.vue?vue&type=script&lang=js"
export * from "./AdminAlertMessage2.vue?vue&type=script&lang=js"
import style0 from "./AdminAlertMessage2.vue?vue&type=style&index=0&id=40acdb19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40acdb19",
  null
  
)

export default component.exports